var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"languages"},_vm._l((_vm.languages),function(language,code){return _c('a',{key:code,on:{"click":function($event){_vm.$root.$i18n.locale = code}}},[_vm._v(_vm._s(language)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }